import * as React from "react";

import Sheet from "@mui/joy/Sheet";
import Table from "@mui/joy/Table";

import {useTable} from "react-table";

import { Loading } from "./Common";
import { Await } from "react-router-dom";

const useMemo = (object) => {
    return React.useMemo(() => object, [object]);
};

//export const D

export const DataTable = ({columns, data, selector}) => {
    const table = useTable({columns: useMemo(columns), data: useMemo(data)});
    return (
        <>
            {selector}
            <Sheet className="dataTable" sx={sxTableSheet} variant="outlined">
                <Table aria-labelledby="dataTable" noWrap stickyHeader stripe="even" sx={sxTable}>
                    <thead>
                    {table.headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => {
                                return (
                                    <th key={column.Header}
                                        style={{padding: 12, width: column.width}}>{column.render("Header")}</th>
                                );
                            })}
                        </tr>
                    ))}
                    </thead>
                    <tbody>
                    {table.rows.map((row, i) => {
                        table.prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </Table>
            </Sheet>
        </>
    );
};

const Caption = ({caption}) => {
    return caption ? <caption>{caption}</caption> : null;
};

// css

const sxTable = (theme) => {
    return {
        "--TableCell-headBackground": (theme) =>
            theme.vars.palette.background.level1,
        "--Table-headerUnderlineThickness": "1px",
        "--TableRow-hoverBackground": (theme) =>
            theme.vars.palette.background.level1
    };
};

const sxTableSheet = {
    width: "100%",
    borderRadius: "md",
    //flex: 1,
    overflow: "auto",
    minHeight: 0
};